import Swiper from 'swiper'

export default {
  data () {
    return {
      articleContent: null,
      contentSlider: []
    }
  },
  methods: {
    setContents () {
      this.$nextTick(() => {
        this.articleContent = this.$el.querySelector('.article-detail-content')

        this.setContentDownload()
        this.setContentSlider()

        this.setTopSlider()
      })
    },
    setTopSlider () {
      const slider = this.articleContent.querySelector('[data-images]')
      const options = {
        // autoplay: true,
        loop: true,
        centeredSlides: true,
        // autoHeight: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.top-slider.swiper-button-next',
          prevEl: '.top-slider.swiper-button-prev',
        },
        on: {
          slideChange (s) {
            const index = s.activeIndex
            const comment = s.slides[index].dataset.comment
            slider.parentNode.querySelector('.slide-caption').innerHTML = comment || ''
          }
        }
      }

      if (!slider) {
        return false
      }

      // console.log(slider.dataset.images.replace(/(\[|\])*/gi, ''))

      let imageList = slider.dataset.images
          // .replace(/url:/gi, '"url":')
          // .replace(/comment:/gi, '"comment":')
          // .replace(/:(\s*)'/gi, ':"')
          // .replace(/'([,|}])/gi, '"$1')

      function insertAfter (referenceNode, newNode) {
        if (referenceNode.nextSibling) {
          referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
        } else {
          referenceNode.parentNode.appendChild(newNode)
        }
      }

      function setSliderElement () {
        slider.classList.add('swiper', 'slide-top')
        slider.innerHTML = ''

        imageList = JSON.parse(imageList)

        const wrapper = document.createElement('div')
        wrapper.classList.add('swiper-wrapper')
        slider.appendChild(wrapper)

        const prev = document.createElement('button')
        prev.classList.add('swiper-button-prev', 'top-slider')
        slider.appendChild(prev)

        const next = document.createElement('button')
        next.classList.add('swiper-button-next', 'top-slider')
        slider.appendChild(next)

        const comment = document.createElement('div')
        comment.classList.add('slide-caption')
        // slider.appendChild(comment)
        insertAfter(slider, comment)

        imageList.forEach(item => {
          const slide = document.createElement('div')
          slide.classList.add('swiper-slide')
          if (item.comment) { slide.dataset.comment = item.comment }
          wrapper.appendChild(slide)

          const imageWrap = document.createElement('div')
          imageWrap.classList.add('slide-image')
          slide.appendChild(imageWrap)

          const image = document.createElement('img')
          image.setAttribute('src', item.url)
          imageWrap.appendChild(image)
        })

        if (imageList.length > 1) {
          setTimeout(() => {
            // eslint-disable-next-line
            new Swiper(slider, options)
          }, 300)
        }
      }

      try {
        setSliderElement()
      } catch (e) {
        imageList = /(?:<div data-images=')((?:.|[\r\n])+)(?:'><\/div>)/gm.exec(this.desserts.content)[1]
        imageList = imageList.replace('', '')
        imageList = imageList.replace(/[\n\r]*/gi, '')

        setSliderElement()
      }
    },
    setContentSlider () {
      const options = {
        // autoplay: true,
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }

      const slider = this.articleContent.querySelectorAll('.swiper');

      [].forEach.call(slider, (item, i) => {
        // eslint-disable-next-line
        new Swiper(item, options)
      })
    },
    setContentDownload () {
      const downloads = this.articleContent.querySelectorAll('[download]');

      [].forEach.call(downloads, item => {
        item.addEventListener('click', e => {
          e.preventDefault()
          this.downloadHandler(e.target)
        })
      })
    },
    downloadHandler (target) {
      const url = target.href
      const name = target.getAttribute('download')

      fetch(url).then((response) => {
        return response.blob()
      }).then((blob) => {
        // IE and edge not works with a.click() for downloading
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name)
        } else {
          const a = document.createElement('a')
          a.href = URL.createObjectURL(blob)
          a.download = name
          a.click()
        }
      })
    }
  }
}

/*
<div data-images="[
{text: '', image: 'https://woowahan-cdn.woowahan.com/new_resources/image/report/press/282/75eddc4b-e92d-4f1a-9296-c85a40f593af.jpg'},
{text: '12월 3일 열린 2021 대한민국광고대상에서 우아한형제들의 ‘너에게 밥을 보낸다’ 캠페인이 TV 영상부문 금상을 수상했다. 왼쪽부터 방송통신위원회 김현 부위원장, 우아한형제들 장인성 브랜딩실장, HS애드 손영준 팀장, 매터스인류크 김민식 PD.', image: 'https://woowahan-cdn.woowahan.com/new_resources/image/report/press/283/a72bb538-4636-4f4f-bbea-08a275e9eb63.jpg'},
{text: '', image: 'https://woowahan-cdn.woowahan.com/new_resources/image/report/press/284/8ced719d-8e5c-4634-90b1-7acecde8addf.jpg'}
]">
* */
